export default __webpack_public_path__ + "static/media/dash.4beba46a.svg";